import PAGE_URLS from 'constants/pageUrls';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import useUserOperations from 'utils/customHooks/userOperations';

const PrivateRoute = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useUserOperations();
  useEffect(() => {
    if (!isLoggedIn) navigate(`/${PAGE_URLS.LOGIN}`);
  }, [navigate, isLoggedIn]);

  return <>{isLoggedIn && <Outlet />}</>;
};

export default PrivateRoute;
